import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 인스타그램_상품글_편집기_라우터 = {
  루트: {
    path: '/products/instagram/editor/:shopID/:taskID/:saleItemID',
    async lazy() {
      const { default: Page } = await import('@/router/products/instagram-post-editor/InstagramPostEditor');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품글 미리보기/편집',
    },
  } satisfies LookoRouteObject,
};

export const 인스타그램_상품글_편집기_루트: LookoRouteObject = {
  path: '/',
  element: (
    <MainLayoutBase headerHeight={0}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(인스타그램_상품글_편집기_라우터),
};
